import { render, staticRenderFns } from "./linker.vue?vue&type=template&id=386767d4&lang=html"
import script from "./linker.vue?vue&type=script&lang=js"
export * from "./linker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports